/**
 * Skeleton dos Retornos — header padrão + navegador de mês + a lista de
 * pacientes a chamar.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-5xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      <div className="flex flex-col gap-4">
        {/* Navegador de mês */}
        <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-white px-3 py-3">
          <div className="h-8 w-8 rounded-lg bg-slate-100" />
          <div className="h-4 w-32 rounded bg-slate-200" />
          <div className="h-8 w-8 rounded-lg bg-slate-100" />
        </div>

        <div className="flex items-center justify-between px-1">
          <div className="h-3 w-28 rounded bg-slate-200" />
          <div className="h-3 w-24 rounded bg-slate-100" />
        </div>

        {/* Lista */}
        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
          {[0, 1, 2, 3].map((r) => (
            <div key={r} className="flex items-center justify-between border-b border-slate-100 p-3 last:border-0">
              <div className="space-y-1.5">
                <div className="h-4 w-44 rounded bg-slate-200" />
                <div className="h-3 w-28 rounded bg-slate-100" />
              </div>
              <div className="flex gap-1.5">
                <div className="h-7 w-20 rounded-md bg-slate-100" />
                <div className="h-7 w-16 rounded-md bg-slate-100" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
